// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

//Test Server SDK
// const firebaseConfig = {
//   apiKey: "AIzaSyDnCDJWxCsGGrv2AkNI9ivhDAsu7yCbcwk",
//   authDomain: "codeisfun-chat.firebaseapp.com",
//   projectId: "codeisfun-chat",
//   storageBucket: "codeisfun-chat.appspot.com",
//   messagingSenderId: "373474618682",
//   appId: "1:373474618682:web:c96a50326a0e61986db403",
//   measurementId: "G-V2NCR6QG6S",
// };

//Live Server SDK
const firebaseConfig = {
  apiKey: "AIzaSyA9TMb4PGODzVoz03F_3jBguJqVKavwXNc",
  authDomain: "codeisfunlive.firebaseapp.com",
  projectId: "codeisfunlive",
  storageBucket: "codeisfunlive.appspot.com",
  messagingSenderId: "1098297956068",
  appId: "1:1098297956068:web:7ffccf4e8f357bb010bef1",
  measurementId: "G-5DV15DDGJL",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
